import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { IMoveToProjectParams } from '~src/projects/ServerApi/types/IMoveToProjectParams';

export class MoveDatasourcesToProjectRequest extends Request<IMoveToProjectParams, IResult> {
  constructor(params: IMoveToProjectParams) {
    super('moveDatasourcesToProject', params);
  }
}
